<template>
    <div ref="element" @mousemove="magnetizeMe($event, $refs.element)" @mouseleave="deMagnetize($refs.element)">
        <slot />
    </div>
</template>

<script>
import magnitize from './magnetic-links';

export default {
    props: {
        force: {
            type: Number,
            default: 20
        }
    },

    methods: {
        magnetizeMe(ev, element) {
            magnitize.start(ev, this.$el, element, this.force);
        },

        deMagnetize(element) {
            magnitize.stop(element);
        }
    }
};
</script>
